// Ajax

var ajaxLoad = {
  ajaxurl: '',
  xhr: '',
  historyTitle: '',
  modalClass: '',
  modal_is_open: false,
  setState: false,
  is_closeing: false,

  init: function () {
    var s = this;
    s.historyTitle = document.title;
    s.root_url = window.location.href;

    if (window.history && window.history.pushState) {
      s.can_history = true;
      window.history.replaceState(null, document.title); //刷新页面时清除 history
      s.addHistoryEvent();
    }

    $('#post-modal .modal-close-btn').off('click').on('click.back', function () {
      s.closeModal();
    });
    $('#post-modal .modal-bg').on('click', function () {
      s.closeModal();
    });

    // AJAX请求的默认参数
    $(document).ajaxError(function (event, jqxhr, settings, thrownError) {
      // modal.closebg();
      // $('.ajax-loader').remove();

      switch (jqxhr.status) {
        case (500):
          // alert("服务器系统内部错误！请稍后再试。");
          alert("Server system error! Please try again later.");
          break;
        case (401):
          // alert("未登录！请登录后再试。");
          alert("Not logged in! Please log in and try again.");
          break;
        case (403):
          // alert("抱歉！您无权限执行此操作！");
          alert("Sorry! You do not have permission to perform this operation!");
          break;
        case (404):
          // alert("未找到您请求的地址！");
          alert("The requested address was not found!");
          break;
        case (408):
          // alert("请求超时！请稍后再试。");
          alert("Request timeout! Please try again later.");
          break;
        // default:
        // alert(jqxhr.status);
      }
    });

    // $(document).ajaxStop(function(){
    //   $('.ajax-loader').remove();
    // });
  },

  alink: function (element, set_history, modal_class) {
    var s = this;
    s.setState = s.can_history && set_history ? true : false;

    var click_e = function (el) {
      if (el.is('.no_ajax')) return;
      el.off('click').on('click', function (e) {
        var linkUrl = el.attr('href');
        var post_id = el.data('postid');
        e.preventDefault();
        s.loadPage(post_id, linkUrl, modal_class, ajaxLoad.setState);
        // ajaxLoad.loadPage(api, post_id, post_title, linkUrl, modal_class, ajaxLoad.setState);
      });
    }

    $(element).each(function () {
      var th = $(this);
      if (th.is('a')) click_e(th)
      else {
        th.find('a').each(function () {
          click_e($(this));
        });
      }
    });
  },

  addHistoryEvent: function () {
    var s = this;
    window.addEventListener("popstate", function (event) {
      s.stop();
      var currentState = history.state;
      // console.log(currentState);
      if (tt_save_history != 'tt_modal_history' && tt_save_history != undefined) return;
      // if ($('body').is('.single')) window.location.reload();

      var back_to_root = function () {
        document.title = s.historyTitle;
        // document.querySelector('meta[property="og:title"]').setAttribute('content', s.historyTitle);
        // document.querySelector('meta[name="twitter:title"]').setAttribute('content', s.historyTitle);
        // document.querySelector('meta[property="og:url"]').setAttribute('content', s.root_url);
      }
      
      if (currentState === null) {
        // history.pushState(null, '', ''); // Safari bug: 页面回滚到顶部
        
        document.title = s.historyTitle;
        if ($('body').is('.modal-show') && s.root_url == window.location.href) {
          modal.close();
          back_to_root();
        } else window.location.reload();
      } else {
        // var aurl = currentState['api'];
        var mdclass = currentState['mdclass'];
        // var pid = currentState['pid'];
        // console.log(mdclass);
        if ($('#post-modal').length && mdclass != '' && mdclass != undefined) {
          s.loadPage(currentState['pid'], currentState['link'], mdclass, false);
          // document.querySelector('meta[property="og:title"]').setAttribute('content', currentState['title']);
          // document.querySelector('meta[name="twitter:title"]').setAttribute('content', currentState['title']);
          // document.querySelector('meta[property="og:url"]').setAttribute('content', currentState['link']);
          // document.title = currentState['title'];
        } else {
          if ($('body').is('.modal-show')) modal.close();
          back_to_root();
          // else window.location.reload();
        }
      }
    });
  },

  setHistory: function (post_id, page_title, linkUrl, modal_class) {
    var s = this;
    var cstate = history.state;
    // console.log(cstate);
    var c_step = 0;
    if (cstate != null && cstate['step'] != undefined) c_step = cstate['step'];
    var end_step = $('body').is('.modal-show') ? c_step + 1 : c_step;
    // console.log(c_step);
    // console.log(end_step);
    var state = {
      // api: apiUrl,
      pid: post_id,
      step: end_step,
      title: page_title,
      link: linkUrl,
      mdclass: modal_class
    };
    history.pushState(state, page_title, linkUrl);
    s.historyTitle = document.title;
    document.title = page_title;

    // document.querySelector('meta[property="og:title"]').setAttribute('content', page_title);
    // document.querySelector('meta[name="twitter:title"]').setAttribute('content', page_title);
    // document.querySelector('meta[property="og:url"]').setAttribute('content', linkUrl);

    tt_save_history = 'tt_modal_history';
  },

  loadPage: function (post_id, linkUrl, modal_class, set_state) {
    var s = this;
    var modal_el = $('#post-modal');
    var modal_scrollwrap = modal_el.find('.modal-scroll-wrap');
    var cont_el = modal_el.find('.modal-cont');

    if (ttLightBox) ttLightBox.close();
    if (ttSkrollr) ttSkrollr.kill('modal_scroll_wrap');

    if (modal_el.is('.showin')) {
      modal_el.data('scrolltop-' + modal_el.data('postid'), modal_scrollwrap.scrollTop());
      
      // modal_scrollwrap.scrollTo(0, 400);
      modal_el.addClass('change');
      var anim_time = parseFloat(cont_el.css('transition-duration')) * 1000;
      setTimeout(function () {
        // $('.bottom-modal-close-btn').remove();
        cont_el.html('').removeAttr('style');
        modal.addLoader();
        loadData();
      }, anim_time);
    } else {
      modal.openbg();
      loadData();
    }

    function loadData() {
      // var _type = $('html').is('.wp') ? 'post' : 'get';
      s.xhr = $.ajax({
        type: 'get',
        url: linkUrl,
        // data: { postid: data_id },
        dataType: "html"
      }).done(function (data) {
        // console.log(data);
        loaded(data);
      });
    }

    function loaded(data) {
      s.ajaxurl = linkUrl;

      modal_el.removeClass(s.modalClass).addClass(modal_class);
      s.modalClass = modal_class;
      modal_el.data('postid', post_id);
      
      var wrapper = document.createElement('div');
      wrapper.innerHTML = data;

      var titleEl = wrapper.querySelector('title');

      var history_set_state = function () {
        if (set_state) {
          var page_title = titleEl.textContent;
          s.setHistory(post_id, page_title, linkUrl, modal_class);
        }
      }

      var main_el = wrapper.querySelector('main');

      cont_el.html( $(main_el).html() );
      cont_el = $('#post-modal .modal-cont');
      cont_el.find('img').attr("oncontextmenu", "return false").attr("ondragstart", "return false");

      if (s.modal_is_open) {
        var end_scrolltop = modal_el.data('scrolltop-' + post_id) || 0;
        // console.log(end_scrolltop);
        modal_scrollwrap.scrollTop(end_scrolltop);
      }

      var preload_img_els = cont_el.find('.preload_img');

      if (preload_img_els.length > 0) {
        preload();
      } else {
        showCont();
      }

      function preload() {
        var preload_img = preload_img_els.eq(0);
        var img_url;
        if (preload_img.is('img')) img_url = preload_img.attr('src');
        else img_url = preload_img.data('img') || preload_img.children('img.hide').attr('src');
        var image = new Image();
        image.src = img_url;
        image.complete ? showCont() : image.onload = showCont;
      }

      function showCont() {
        if (s.ajaxurl != '') {
          cont_el.find('.preload_img:not(img), .coverbg[data-img]').each(function () {
            var img_url = $(this).data('img') || $(this).children('img.hide').attr('src');
            $(this).css('background-image', 'url(' + img_url + ')');
            $(this).children('img.hide').remove();
          });
          
          // if ($('.modal').is('.product')) singleProduct.init('.modal');
          if (ttSkrollr) ttSkrollr.init('modal_scroll_wrap');

          if (modal_el.is('.showin')) {
            modal_scrollwrap.addClass('change-trans');
            setTimeout(function () {
              modal_scrollwrap.removeClass('change-trans');
              modal.open();
              history_set_state();
            }, 400);
          } else {
            modal.open();
            history_set_state();
            s.modal_is_open = true;
          }
          
          setTimeout(function () {
            // ttIdLink.init();
            // ttForm.init();
            // ttFluentform.init();
            
            // if (cont_el.find('#enquire_btn').length) formModal.init();
            
            if (cont_el.find('.ttswiper').length && ics) ttSwiper.init();
            if (cont_el.find('.anim_emt').length && ics) animElements.init();
            if (cont_el.find('.pswp-gallery').length && ics) ttLightBox.init();
            if (cont_el.find('.video-wrap').length) ttVideo.init();
            if (cont_el.find('.cd-handle').length) ttComparison.init();
            if (cont_el.find('.pop').length) pop.init();
            if (cont_el.find('.fixed-title').length) scrollFixNav.fix_title( modal_el, modal_scrollwrap );


            // if (cont_el.find('.ajax_pdc').length)
            //   s.alink('#post-modal .ajax_pdc', true, 'product');
            
            if (cont_el.find('.ajax_pjc').length)
              s.alink('#post-modal .ajax_pjc', true, 'project');
            
            // if (cont_el.find('.ajax_news').length)
            //   s.alink('#post-modal .ajax_news', true, 'news');
            
            // if (modal_el.is('.news') && cont_el.find('.prev-next-nav').length)
            //   s.alink('#post-modal .prev-next-nav .tooltip', true, 'news');

            // if (cont_el.find('input.qty').length) ttForm.input_qty();
            // if (cont_el.find('.input-group-number').length) ttForm.input_group_number();

            // if (modal_el.is('.news') && body_el.is('.post-type-archive-news')) {
            //   $('#allnews_btn').click(function (e) {
            //     e.preventDefault();
            //     s.closeModal();
            //   })
            // }
            
          }, 500);
        }
      }
    }
  },

  closeModal: function () {
    var s = this;
    if (s.is_closeing) return;
    s.is_closeing = true;

    if (s.setState) {
      var state_step = history.state['step'];
      // console.log(state_step);
      history.go(-state_step);
      // history.go(-1);
    } else {
      s.stop();
      modal.close();
    }
  },

  stop: function () {
    var s = this;
    if (s.xhr) s.xhr.abort();
    s.ajaxurl = '';
  }

}
